export const BELIMO_HASH_PREFIX = '/msdynttrid';
